import Bowser from "bowser";
import CryptoJS from "crypto-js";

(function () {

  // if not stream tester page, return and skip rest of script
  if (!document.getElementById('stream-tester')) {
    return;
  }

  // dom elements
  var win = $(window),
    hlsStreamFile = $('#hls-stream-input'),
    mpdStreamFile = $('#mpd-stream-input'),
    hlsStreamFileStandalone = $('#hls-stream-input-standalone'),
    mpdStreamFileStandalone = $('#mpd-stream-input-standalone'),
    primaryInputEl = $('[name="primary"]'),
    hlsInputEl = $('[name="hls"]'),
    drmEl = $('#drm'),
    drmItemCustomDataInputEl = $('[name="drm-item-custom-data"]'),
    drmClearkeyKeyInputEl = $('#drm-clearkey-key'),
    drmClearkeyKeyIdInputEl = $('#drm-clearkey-key-id'),
    drmFairplayCertificateUrlInputEl = $('#drm-fairplay-certificate-url'),
    drmFairplayProcessSpcUrlInputEl = $('#drm-fairplay-process-spc-url'),
    buttonEl = $('[name="button"]'),
    configButton = $('[name="config-button"]'),
    testOutputEl = $('#test-output'),
    outputCodeEl = $('#output-code'),
    drmToggle = $('[name="drm-toggle"]'),
    drmCustomKeyInput = $('#drm-custom-header-key'),
    drmCustomValueInput = $('#drm-custom-header-value'),
    drmHeaderToggle = $('[name="drm-custom-header-toggle"]'),
    drmHeaderParentDiv = $('#drm-custom-header'),
    drmHeaderCustomDataInputEl = $('[name="drm-item-custom-header"]'),
    drmWideVineCustomLicenseUrl = $('#drm-widevine-license-url'),
    drmPlayreadyCustomLicenseUrl = $('#drm-playready-license-url'),
    drmLicenseUrlToggle = $('[name="drm-custom-license-url-toggle"]'),
    drmLicenseUrlParentDiv = $('#drm-custom-license-url'),
    drmLicenseUrlCustomDataInputEl = $('[name="drm-item-custom-license-url"]'),
    drmClearkeyToggle = $('[name="drm-clearkey-toggle"]'),
    drmClearkey = $('#drm-clearkey'),
    buttonTab = $('[name="tab-button"]');
    
  var playerLoadBool = false;

  function setFromQueryParams(id, param){
    var field = document.getElementById(id);
    var urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has(param)) {
      field.value = urlParams.get(param);
      if (param == 'token' || param == 'headerValue'){
        // Handle cases where URL decoding might break a value
        field.value = field.value.replace(" ", "+");
      }
      return true;
    }
    return false;
  }

  function setStreamingUrls(urlParams){
    if (!isSafariCheck()){
      if (urlParams.has('mpdStream')){
        setFromQueryParams('mpd-stream-input-standalone', 'mpdStream');
        setFromQueryParams('mpd-stream-input', 'mpdStream');
        document.getElementById('hls-stream-input').value = '';
        document.getElementById('hls-stream-input-standalone').value = '';
      }
      else if (urlParams.has('hlsStream')) {
        setFromQueryParams('hls-stream-input-standalone', 'hlsStream');
        setFromQueryParams('hls-stream-input', 'hlsStream');
        document.getElementById('mpd-stream-input').value = '';
        document.getElementById('mpd-stream-input-standalone').value = '';
      }
    }
    else {
      if (urlParams.has('hlsStream')){
        setFromQueryParams('hls-stream-input-standalone', 'hlsStream');
        setFromQueryParams('hls-stream-input', 'hlsStream');
        document.getElementById('mpd-stream-input').value = '';
        document.getElementById('mpd-stream-input-standalone').value = '';
      }
      else {
        setFromQueryParams('mpd-stream-input-standalone', 'mpdStream');
        setFromQueryParams('mpd-stream-input', 'mpdStream');
        document.getElementById('hls-stream-input').value = '';
        document.getElementById('hls-stream-input-standalone').value = '';
      }
    }
  }

  function setToggleEvent(element){
    element.checked  = true;
    var toggleEvent = new Event('change', {bubbles: true, cancelable: true});
    element.dispatchEvent(toggleEvent);
  }

  function getQueryParams() {
    var urlParams = isUrlParamsSet();
    if (urlParams){
      var mediaExists = setFromQueryParams('media-id-input', 'mediaId');
      setFromQueryParams('api-secret-input', 'secret');
      setFromQueryParams('policy-id-input', 'policyId');
      setStreamingUrls(urlParams);
      var drmCheck = urlParams.get('isDRM');

      if (drmCheck === 'true'){
        setToggleEvent(document.getElementById('drm-toggle'));
        if (urlParams.has('headerKey')){
          setFromQueryParams('drm-custom-header-key', 'headerKey');
          setFromQueryParams('drm-custom-header-value', 'headerValue');

          customHeaderHelperFunction('key', urlParams.get('headerKey'));
          customHeaderHelperFunction('value', urlParams.get('headerValue'));
          setToggleEvent(document.getElementsByName('drm-custom-header-toggle')[0]);
        }
        if (urlParams.has('widevine')){
          setFromQueryParams('drm-widevine-license-url', 'widevine');
          customLicenseUrlHelperFunction('widevine', urlParams.get('widevine'));
          setToggleEvent(document.getElementsByName('drm-custom-license-url-toggle')[0]);
        }
        if (urlParams.has('playready')){
          setFromQueryParams('drm-playready-license-url', 'playready');
          customLicenseUrlHelperFunction('playready', urlParams.get('playready'));
          setToggleEvent(document.getElementsByName('drm-custom-license-url-toggle')[0]);
        }
        if (urlParams.has('fairplayCert') || urlParams.has('fairplayLicense')){
          setFromQueryParams('drm-fairplay-certificate-url', 'fairplayCert');
          setFromQueryParams('drm-fairplay-process-spc-url', 'fairplayLicense');
          data.placeholderDrm.fairplay.certificateUrl = urlParams.get('fairplayCert');
          data.placeholderDrm.fairplay.processSpcUrl = urlParams.get('fairplayLicense');
          setToggleEvent(document.getElementsByName('drm-custom-license-url-toggle')[0]);
        }
        if (urlParams.get('clearkey')){
          setFromQueryParams('drm-clearkey-key', 'clearkey');
          setFromQueryParams('drm-clearkey-key-id', 'clearkeyId');
          setToggleEvent(document.getElementsByName('drm-clearkey-toggle')[0]);
          customClearkeyHelperFunction('key');
          customClearkeyHelperFunction('keyId');
        }
      }
      var tokenExists = setFromQueryParams('token-input', 'token');
      if (mediaExists) {
        getCurrentTab("jwplatform-tab");
        openTab("jwplatform-tab");
      }
      else if (tokenExists) {
        getCurrentTab("standalone-tab");
        openTab("standalone-tab");
      }
      else {
        getCurrentTab("custom-tab");
        openTab("custom-tab");
      }
      
      return true;
    }
    return false;
  }

  function isUrlParamsSet(){
    var urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.toString() == "") {
      return urlParams;
    }
    else {return false;}
  }

  document.getElementById("custom-drm-label").setAttribute("bgcolor", "#F3F5F8");

  function openTab(nextTab) {
    var tabcontent;
    tabcontent = document.getElementsByClassName("tabcontent");
    if (nextTab.includes("jwplatform")){
      showTabContent(0, tabcontent);
    }
    else if (nextTab.includes("standalone")){
      showTabContent(1, tabcontent);
    }
    else{
      showTabContent(2, tabcontent);
    }
  }

  function showTabContent(element, tablist){
    for (var i=0; i<tablist.length; i++){
      if (i == element){
        tablist[i].style.display = "block";
      }
      else {
        tablist[i].style.display = "none";
      }
    }
  }

  function getActiveTab(){
    var cList = document.getElementsByClassName("tablinks");
    for (var i=0; i<cList.length; i++){
      if(cList[i].classList.contains("active")){
        return cList[i].id;
      }
    }
  }

  /* Handles the Custom DRM Toggle color change */
  function sliderToggleBackground(obj){
    if($(obj).is(":checked")){
      document.getElementById("custom-drm-label").setAttribute("bgcolor", "#D2EBFF");
      document.getElementById("drm-toggle-label").style.color = "#07529F";
    }else{
      document.getElementById("custom-drm-label").setAttribute("bgcolor", "#F3F5F8");
      document.getElementById("drm-toggle-label").style.color = "#2f3542";
    }
  }

  function getCurrentTab(tabId){
    var nextTab = tabId;
    const tab = document.getElementsByClassName("tab");
    const children = tab.item(0).children;
    for (var i=0; i<children.length; i++){

      // Checks if user clicked the currently active tab
      if(children.item(i).id != nextTab){
        if (children.item(i).classList.contains("active")){
          children.item(i).classList.remove("active");
        }
      }
      else {
        if (children.item(i).classList.contains("active")){
          return;
        }
        var tabId = children.item(i);
        tabId.classList.add("active");
      }
    }
    return nextTab;
  }

  // player instance
  var playerInstance = null;

  // local config object
  var config = {};

  // player config object
  var playerConfig = {};

  // temp item config with default keys
  var data = {
    file: hlsStreamFile.val(),
    fileProtocol: location.protocol,
    primary: 'html5',
    hlshtml: true,
    hls: false,
    drm: null,
    drmToggle: false,
    headerToggle: false,
    licenseUrlToggle: false,
    fairplayCertToggle: false
  };

  function getJWT(mediaId, secret, policyId){
    function createJwt(path, secret) {
      var header = {
          "alg": "HS256",
          "typ": "JWT"
      };
      var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
      var encodedHeader = base64url(stringifiedHeader);
      var now = new Date();
      var exp = new Date(now.getTime() + 5*60000);
      var expUnix = exp.getTime()/1000;
      var data = {
          "resource": path,
          "exp": expUnix
      }
      var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
      var encodedData = base64url(stringifiedData);
      var token = encodedHeader + "." + encodedData;
      var signature = CryptoJS.HmacSHA256(token, secret);
      signature = base64url(signature);
      var signedToken = token + "." + signature;
      return signedToken;
    }

    function base64url(source) {
      // Encode in classical base64
      var encodedSource = CryptoJS.enc.Base64.stringify(source);

      // Remove padding equal characters
      encodedSource = encodedSource.replace(/=+$/, '');

      // Replace characters according to base64url specifications
      encodedSource = encodedSource.replace(/\+/g, '-');
      encodedSource = encodedSource.replace(/\//g, '_');

      return encodedSource;
    }

    var api_secret = secret;
    var policy_id = policyId;
    var media_id = mediaId;
    var path = "/v2/media/"+media_id+"/drm/"+policy_id;
    var jwt = createJwt(path, api_secret);
    return jwt;
  }

  function getMediaInfo(url, mediaId){
    var xhr = new XMLHttpRequest();
    if (!isUrlParamsSet()) {
      if (jwplayer() !== "undefined"){
        // Removes old player, otherwise will error until below event occurs
        jwplayer().remove();
      }
    }
    xhr.addEventListener("readystatechange", function(){
      if (this.readyState === 4) {
          var mediaInfo = JSON.parse(this.responseText);
          if(mediaInfo.playlist){
            config = mediaInfo.playlist[0];
          }
          else{
            // Since we remove the player above,
            // here we force a player error if a media id is invalid
            var file = "https://cdn.jwplayer.com/manifests/" + mediaId + ".m3u8"
            config = {
              playlist: [{
                file: file
            }]
          }
        }
          setPlayerInstance(playerLoadBool);
      }
    });
    xhr.open("GET", url);
    xhr.send();
  }

  function updateConfig(autostart, drmTab, c) {
    playerLoadBool = true;
    if (drmTab == 'platform'){
      var mediaId = $('#media-id-input').val();
      var secret = $('#api-secret-input').val();
      var policyId = $('#policy-id-input').val();
      var root = "https://cdn.jwplayer.com/v2/media/";
      var path;
      var url;

      // Assume without a policy ID the request is for non-DRM media, and make the appropriate request
      if (policyId === ""){
        path = mediaId;
        url = root + path;
        getMediaInfo(url, mediaId);
      }
      else {
        var token = getJWT(mediaId, secret, policyId);
        path = mediaId + "/drm/" + policyId + "?token=" + token;
        url = root + path;
        getMediaInfo(url);
      }
    }
    else if (drmTab == 'standalone'){
      const widevineLaurl = "https://widevine-license.vudrm.tech/proxy";
      var fairplayCert = "https://fairplay-license.vudrm.tech/certificate/";
      const playreadyLaurl = "https://playready-license.vudrm.tech/rightsmanager.asmx";
      var vudrmToken = $('#token-input').val();
      mpdStreamFileStandalone = $('#mpd-stream-input-standalone').val();
      hlsStreamFileStandalone = $('#hls-stream-input-standalone').val();
      var clientName = vudrmToken.split("|")[0];

      fairplayCert = fairplayCert + clientName;
      config = {
        playlist: [{
          sources: [{
            file: mpdStreamFileStandalone,
            drm: {
              widevine: {
                url: widevineLaurl,
                headers: [{
                  name: "X-VUDRM-TOKEN",
                  value: vudrmToken
                }]
              },
              playready: {
                url: playreadyLaurl,
                headers: [{
                  name: "X-VUDRM-TOKEN",
                  value: vudrmToken
                }]
              }
            }
          },
          {
            file: hlsStreamFileStandalone,
            drm: {
              fairplay: {
                certificateUrl: fairplayCert,
                processSpcUrl: function (initData) {
                  return "https://" + initData.split("skd://").pop();
              },
                licenseRequestHeaders: [
                  {
                    name: "Content-type",
                    value: "arraybuffer"
                  },
                  {
                    name: "X-VUDRM-TOKEN",
                    value: vudrmToken
                  }
                ]
              }
            }
          }]
        }]
      };
      setPlayerInstance(playerLoadBool);
    }
    else if (drmTab == 'custom'){
        config = c;
        setPlayerInstance(playerLoadBool);
    }
   
    // If the function was called with the autostart flag (literally true or false), use in the setup config.
    // Otherwise, default to whatever was set in the dashboard.
    if (typeof autostart !== 'undefined') {
      config.autostart = false;
    }
  }

  // TODO: Consolidate this logic with that which is in the Ad Tester.
  function setPlayerLibrary(version) {
    var script = document.createElement('script');
    var versionRadios = document.querySelectorAll('input[name="version"]');
    script.src = "https://content.jwplatform.com/libraries/KB5zFt7A.js";
    document.body.appendChild(script);

    Array.prototype.slice.call(versionRadios).forEach(function (input) {
      input.addEventListener('click', switchPlayerLibrary);
      input.checked = input.value === version;
    });
    return Promise.resolve();
  }

  function switchPlayerLibrary(e) {
    var current = document.location.href.split('?')[0];
    document.location.href = current + '?playerversion=' + e.target.value;
  }
  // End TODO

  function setDrmDisplay() {
    if (data.hlshtml) {
      drmEl.removeClass('drm-not-supported');
    } else {
      drmEl.addClass('drm-not-supported');
    }
  }

  function toggleDrmItemDisplay(el) {
    if (el[0].classList.contains('drm-item-selected')) {
      el[0].classList.remove('drm-item-selected');
    } else {
      el[0].classList.add('drm-item-selected');
    }
  }

  function setOutput() {
    outputCodeEl.html(JSON.stringify(config, null, 2));
    testOutputEl.addClass('test-output-visible');
    hljs.highlightBlock(outputCodeEl[0]);
  }

  function setPlayerInstance(buttonFlag) {
    // Sets up default player if not called after a 'test stream' button was pressed
    if (!buttonFlag){
      config = {
        playlist: [{
          file: "https://content.jwplatform.com/manifests/yp34SRmf.m3u8"
        }]
      }
      playerInstance = jwplayer('stream-tester-player-https').setup(config);
    }
    else {
      var testPlayerConfig = config;
      playerInstance = jwplayer('stream-tester-player-https').setup(testPlayerConfig);
      playerInstance.on('error setupError', function (data) {
        if (data && data.code && data.message) {
          var errorDiv = document.querySelector('.jw-error-msg');
          errorDiv.addEventListener('click', function () {
            window.open('https://developer.jwplayer.com/jwplayer/docs/jw8-player-errors-reference#' + data.code);
          });
        }
      });
    }
  }

  function protocolAlert() {
    if (window.location.protocol === data.fileProtocol) {
      playerConfig = Object.create(config);
      playerInstance = jwplayer('stream-tester-player-https').setup(playerConfig);
    } else {
      alert('This stream tester supports testing & debugging HTTPS streams. Please visit http://stream-tester.jwplayer.com/ to test HTTP streams.');
    }
  }

  // alert for http://stream-tester.jwplayer.com/ domain only
  function httpTesterAlert() {
    if (window.location.protocol === 'http') {
      playerConfig = Object.create(config);
      playerInstance = jwplayer('stream-tester-player-https').setup(playerConfig);
    } else {
      alert('You are currently using our deprecated HTTP stream tester. Please visit developer.jwplayer.com/tools/stream-tester/ to securely test HTTPS streams with the latest version of the JW Player Stream Tester.');
    }
  }

  // initialize stream tester
  function init(autostart, e=null) {
    // TODO: Consolidate this logic with that which is in the Ad Tester.
    var query = document.location.href.split('8')[1];
    var version = query ? query.charAt(0, 1) : '8'; // Default to a library using JW Player 8
    if (e == null){
      getQueryParams();
    }
    buttonTab.click(function (e) {
      e.stopImmediatePropagation();
      var currentTab = getCurrentTab(e.currentTarget.id);
      openTab(currentTab);
    });
    setPlayerLibrary(version)
    // End TODO
    .then(setupConfigs.bind(null, autostart));
  }

  function setupConfigs(autostart) {
    if (typeof jwplayer === 'undefined') {
      return setTimeout(setupConfigs.bind(null, autostart), 100);
    }
    initializeNewConfig();
    if (!playerLoadBool){
      if (URLSearchParams(window.location.search).size == 0) {
        setPlayerInstance(playerLoadBool);
      }
      else {setPlayerInstance(true)}
    }
  }

  hlsStreamFile.on('input', function () {
    if (hlsStreamFile.val().indexOf('m3u8') < 0) {
      data.file = '';
      return;
    }
    data.file = hlsStreamFile.val();
    var url = document.createElement('a');
    url.href = data.file;
    data.fileProtocol = url.protocol;
  });

  mpdStreamFile.on('input', function () {
    if (mpdStreamFile.val().indexOf('mpd') < 0) {
      data.mpdFile = '';
      return;
    }
    data.mpdFile = mpdStreamFile.val();
    var url = document.createElement('a');
    url.href = data.mpdFile;
    data.fileProtocol = url.protocol;
  });

  // update config when render mode option changes
  primaryInputEl.on('change', function () {
    data.primary = primaryInputEl.filter(':checked').val();
    data.hlshtml = data.primary === 'html5';
    setDrmDisplay();
  });

  drmToggle.on('change', function (e) {
    sliderToggleBackground(drmToggle);
    var toggleVal = e.currentTarget.checked;
    var drmItems = document.querySelectorAll('.drm-item');

    if (toggleVal === true) {
      data.placeholderDrm = {
        widevine: {},
        playready: {},
        fairplay: {}
      };
      drmItems.forEach(function (item) {
        return item.style.display = 'block';
      });
      data.drmToggle = true;
      data.fairplayCertToggle = true;
    } else {
      for (var prop in data.placeholderDrm) {
        delete data.placeholderDrm[prop];
      }
      drmItems.forEach(function (item) {
        return item.style.display = 'none';
      });
      data.drmToggle = false;
      data.fairplayCertToggle = false;
      drmFairplayCertificateUrlInputEl[0].value = '';

      // reset fields and checked boxes
      if (drmHeaderToggle[0].checked) {
        drmHeaderToggle[0].checked = false;
        toggleDrmItemDisplay(drmHeaderParentDiv);
      }
      if (drmLicenseUrlToggle[0].checked) {
        drmLicenseUrlToggle[0].checked = false;
        toggleDrmItemDisplay(drmLicenseUrlParentDiv);
      }
      if (drmClearkeyToggle[0].checked) {
        drmClearkeyToggle[0].checked = false;
        toggleDrmItemDisplay(drmClearkey);
      }
    }
  });

  drmItemCustomDataInputEl.on('change', function () {
    var el = $(this),
        elCustomDataEl = el.parent().siblings('.drm-item-custom-data');
    if (el.is(':checked')) {
      elCustomDataEl.addClass('drm-item-custom-data-visible');
    } else {
      elCustomDataEl.removeClass('drm-item-custom-data-visible');
    }
  });

  drmHeaderCustomDataInputEl.on('change', function () {
    var el = $(this),
        elCustomDataEl = el.parent().siblings('.drm-item-custom-header');
    if (el.is(':checked')) {
      elCustomDataEl.addClass('drm-item-custom-data-visible');
    } else {
      elCustomDataEl.removeClass('drm-item-custom-data-visible');
    }
  });

  drmLicenseUrlCustomDataInputEl.on('change', function () {
    var el = $(this),
        elCustomDataEl = el.parent().siblings('.drm-item-custom-license-url');
    if (el.is(':checked')) {
      elCustomDataEl.addClass('drm-item-custom-data-visible');
    } else {
      elCustomDataEl.removeClass('drm-item-custom-data-visible');
    }
  });

  function customHeaderHelperFunction(type, value) {
    if (!value) {
      for (var prop in data.placeholderDrm) {
        if (prop === 'fairplay') {
          delete data.placeholderDrm[prop].licenseRequestHeaders[1][type === 'key' ? 'name' : 'value'];
        } else {
          delete data.placeholderDrm[prop].headers[0][type === 'key' ? 'name' : 'value'];
        }
      }
    } else {
      for (var _prop in data.placeholderDrm) {
        if (_prop === 'fairplay') {
          if (data.placeholderDrm[_prop].licenseRequestHeaders) {
            data.placeholderDrm[_prop].licenseRequestHeaders[1][type === 'key' ? 'name' : 'value'] = value;
          }
        } else {
          if (data.placeholderDrm[_prop] && Object.keys(data.placeholderDrm[_prop].headers ? data.placeholderDrm[_prop].headers : {}).length) {
            data.placeholderDrm[_prop].headers[0][type === 'key' ? 'name' : 'value'] = value;
          }
        }
      }
    }
  }

  function customLicenseUrlHelperFunction(drm, value) {
    if (!value) {
      delete data.placeholderDrm[drm].url;
    } else {
      data.placeholderDrm[drm].url = value;
    }
  }

  function customClearkeyHelperFunction(key) {
    if (key == 'key'){
      data.placeholderDrm.clearkey.key = drmClearkeyKeyInputEl.val();
    }
    else {
      data.placeholderDrm.clearkey.keyId = drmClearkeyKeyIdInputEl.val();
    }
  }

  drmCustomKeyInput.on('keyup', function () {
    customHeaderHelperFunction('key', drmCustomKeyInput.val());
  });
  drmCustomValueInput.on('keyup', function () {
    customHeaderHelperFunction('value', drmCustomValueInput.val());
  });
  drmWideVineCustomLicenseUrl.on('keyup', function () {
    customLicenseUrlHelperFunction('widevine', drmWideVineCustomLicenseUrl.val());
  });
  drmPlayreadyCustomLicenseUrl.on('keyup', function () {
    customLicenseUrlHelperFunction('playready', drmPlayreadyCustomLicenseUrl.val());
  });

  drmClearkeyKeyInputEl.on('keyup', function () {
    customClearkeyHelperFunction('key');
  });

  drmClearkeyKeyIdInputEl.on('keyup', function () {
    customClearkeyHelperFunction('keyId')
  });

  drmFairplayCertificateUrlInputEl.on('keyup', function () {
    if (!drmFairplayCertificateUrlInputEl.val() && data.placeholderDrm.fairplay.certificateUrl) {
      delete data.placeholderDrm.fairplay.certificateUrl;
    } else {
      data.placeholderDrm.fairplay.certificateUrl = drmFairplayCertificateUrlInputEl.val();
    }
  });

  drmFairplayProcessSpcUrlInputEl.on('keyup', function () {
    if (!drmFairplayProcessSpcUrlInputEl.val() && data.placeholderDrm.fairplay.processSpcUrl) {
      delete data.placeholderDrm.fairplay.processSpcUrl;
    } else {
      data.placeholderDrm.fairplay.processSpcUrl = drmFairplayProcessSpcUrlInputEl.val();
    }
  });

  hlsInputEl.on('change', function () {
    data.hls = hlsInputEl.is(':checked');
  });

  drmHeaderToggle.on('change', function (e) {
    var toggleVal = e.currentTarget.checked;

    if (toggleVal) {
      // re-check since these values could've been destroyed through toggling
      if (!data.placeholderDrm.widevine) {
        data.placeholderDrm.widevine = {};
      }
      if (!data.placeholderDrm.playready) {
        data.placeholderDrm.playready = {};
      }
      if (!data.placeholderDrm.fairplay) {
        data.placeholderDrm.fairplay = {};
      }
      if (!data.placeholderDrm.fairplay.licenseRequestHeaders) {
        data.placeholderDrm.fairplay.licenseRequestHeaders = [{
          name: "Content-type",
          value: "arraybuffer"
        }, {
          name: drmCustomKeyInput.val() ? drmCustomKeyInput.val() : null,
          value: drmCustomValueInput.val() ? drmCustomValueInput.val() : null
        }];
      }
      data.headerToggle = true;
      for (var prop in data.placeholderDrm) {
        if (!data.placeholderDrm[prop].headers && prop !== 'fairplay') {
          data.placeholderDrm[prop].headers = [{
            name: drmCustomKeyInput.val() ? drmCustomKeyInput.val() : null,
            value: drmCustomValueInput.val() ? drmCustomValueInput.val() : null
          }];
        }
      }
    } else {
      data.headerToggle = false;
      drmCustomKeyInput[0].value = '';
      drmCustomValueInput[0].value = '';
      formatDrmConfig();
    }
    toggleDrmItemDisplay(drmHeaderParentDiv);
  });

  drmLicenseUrlToggle.on('change', function (e) {
    var toggleVal = e.currentTarget.checked;

    if (toggleVal) {
      // re-check since these values could've been destroyed through toggling
      if (!data.placeholderDrm.widevine) {
        data.placeholderDrm.widevine = {};
      }
      if (!data.placeholderDrm.playready) {
        data.placeholderDrm.playready = {};
      }
      if (!data.placeholderDrm.fairplay) {
        data.placeholderDrm.fairplay = {};
      }
      data.licenseUrlToggle = true;
    } else {
      drmWideVineCustomLicenseUrl[0].value = '';
      drmPlayreadyCustomLicenseUrl[0].value = '';
      drmFairplayProcessSpcUrlInputEl[0].value = '';

      if (data.placeholderDrm.fairplay.processSpcUrl) {
        delete data.placeholderDrm.fairplay.processSpcUrl;
      }

      data.licenseUrlToggle = false;
      formatDrmConfig();
    }
    toggleDrmItemDisplay(drmLicenseUrlParentDiv);
  });

  drmClearkeyToggle.on('change', function (e) {
    var toggleVal = e.currentTarget.checked;

    if (toggleVal) {
      data.clearkeyToggle = true;
      data.placeholderDrm.clearkey = {};
    } else {
      drmClearkeyKeyInputEl[0].value = '';
      drmClearkeyKeyIdInputEl[0].value = '';
      data.clearkeyToggle = false;
      formatDrmConfig();
    }
    toggleDrmItemDisplay(drmClearkey);
  });

  function formatDrmConfig() {
    // clean up of data object which will be used to pass DRM config to main config
    config = {
      playlist: [{
        sources: []
      }],
      primary: data.primary,
      hlshtml: data.hlshtml
    };

    // Fetch current streaming URLs - ignores whether non-DRM media has been played previously
    hlsStreamFile = $('#hls-stream-input').val();
    mpdStreamFile = $('#mpd-stream-input').val();

    for (var prop in data.placeholderDrm) {
      if (!data.headerToggle) {
        if (prop === 'fairplay') {
          delete data.placeholderDrm[prop].licenseRequestHeaders;
        } else {
          delete data.placeholderDrm[prop].headers;
        }
      }
      if (!data.licenseUrlToggle) {
        delete data.placeholderDrm[prop].url;
      }
      if (!data.fairplayCertToggle && prop === 'fairplay') {
        delete data.placeholderDrm[prop];
      }
      if (!data.clearkeyToggle && prop === 'clearkey') {
        delete data.placeholderDrm[prop];
      }
    }
    // handling widevine and playready together like shown in the docs. Use dash by default
    var widevineAndPlayReadyDRM = {
      default: __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.chrome ? true : false,
      file: mpdStreamFile ? mpdStreamFile : hlsStreamFile
    };

    // for loop to push DRM config into playlist sources array.
    for (var _prop2 in data.placeholderDrm) {
      var sourceToAdd = {
        default: __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.safari && _prop2 === 'fairplay' ? true : false,
        file: hlsStreamFile
      };

      if (_prop2 === 'fairplay') {
        sourceToAdd.type = "hls";
        sourceToAdd.drm = {};
        sourceToAdd.drm.fairplay = data.placeholderDrm.fairplay;
      } else if (_prop2 === 'clearkey') {
        // use dash by default
        if (mpdStreamFile) {
          sourceToAdd.file = mpdStreamFile;
        }
        sourceToAdd.drm = {};
        sourceToAdd.drm.clearkey = data.placeholderDrm.clearkey;
      } else {
        if (!widevineAndPlayReadyDRM.drm) {
          widevineAndPlayReadyDRM.drm = {};
        }
        widevineAndPlayReadyDRM.drm[_prop2] = data.placeholderDrm[_prop2];
      }
      
      //if prop was fairplay or clearkey, we would have a drm config on sourceToAdd and we want this added to playlist sources
      if (sourceToAdd.drm) {
        config.playlist[0].sources.push(sourceToAdd);
      }
    }
    if (Object.keys(widevineAndPlayReadyDRM.drm).length) {
      config.playlist[0].sources.push(widevineAndPlayReadyDRM);
    }
    return config;
  }

  function initializeNewConfig() {
    // Get active tab and create correct config based on active tab
    var activeTab = getActiveTab();
    if (activeTab.includes("standalone")){
      updateConfig(true, "standalone");
    }
    else if (activeTab.includes("jwplatform")){
      updateConfig(true, "platform");
    }
    else if (data.drmToggle){
      config = formatDrmConfig();
      updateConfig(true, "custom", config);
    }
    else {
      // Check for whether browser is Safari, and force HLS if so
      var streamingFile;
      var isSafari = isSafariCheck();
      // Make sure streaming files weren't set in another tab
      hlsStreamFile = $('#hls-stream-input').val();
      mpdStreamFile = $('#mpd-stream-input').val();
      if (isSafari){
        streamingFile = hlsStreamFile;
      }
      else if (mpdStreamFile !== ""){
        streamingFile = mpdStreamFile;
      }
      else {
        streamingFile = hlsStreamFile;
      }
      config = {
        playlist: [{
          file: streamingFile
        }]
      }
      updateConfig(true, "custom", config);
    }
  }

  function isSafariCheck(){
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
  }

  // re-initialize player instance with modified config when button is clicked
  buttonEl.on('click', function (e) {
    init(true, e);
    protocolAlert();
    initializeNewConfig();
  });

  configButton.on('click', function () {
    // copy the current player config to clipboard
    navigator.clipboard.writeText(JSON.stringify(config, null, '\t')).then(function(x) {
      alert("Copied player configuration");
    });
  });

  var acceptedOrigins = ['http://stream-tester.jwplayer.com/', 'http://local.developer.jwplayer.com'];

  // initialize default player instance
  init();
})();



// WEBPACK FOOTER //
// ./src/js/tools/stream-tester/index.js